import Vue from 'vue'
import Router from 'vue-router'
const HomePage = () => import('@/components/HomePage')
const Register = () => import('@/components/RegisterPage')
const Login = () => import('@/components/Login')
const Analyse = () => import('@/components/Analyse')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/analyse',
      name: 'Analyse',
      component: Analyse
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js